import { FormConfiguration } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const { ScreenProvider } = ui;

const S9EntityCreateDrawer = ui.S9EntityCreateDrawer.default;
const S9EntityEditDrawer = ui.S9EntityEditDrawer.default;

type EntityDrawerProps = {
  open: boolean;
  onClose: () => void;
  screenQueryName: string;
  entityName: string;
  title: string;
  editRoute: string;
  relativePath: string;
  id?: number;
  initialValues?: any;
  formFields?: FormConfiguration[] | string[];
};

export const EntityDrawer = ({
  open,
  onClose,
  id,
  screenQueryName,
  entityName,
  title,
  editRoute,
  relativePath,
  initialValues = {},
  formFields = [],
}: EntityDrawerProps) => (
  <ScreenProvider relativePath={relativePath}>
    {id === undefined ? (
      <S9EntityCreateDrawer
        title={`Create ${title}`}
        open={open}
        onClose={onClose}
        onSaved={onClose}
        initialValues={initialValues}
        entityKey={entityName}
        formFields={formFields}
        editRoute={editRoute}
        closable
      />
    ) : (
      <S9EntityEditDrawer
        title={`Edit ${title}`}
        screenQueryName={screenQueryName}
        open={open}
        entityKey={entityName}
        entityId={id}
        formFields={formFields}
        initialValues={initialValues}
        closable
        onClose={onClose}
        onSaved={onClose}
        onDeleted={onClose}
      />
    )}
  </ScreenProvider>
);
